import { Badge } from "./ui/badge";

interface StatusBadgeProps {
  status: string;
}

export function AuctionStatusBadge({ status }: StatusBadgeProps) {
  if (status === "live") return <Badge variant="success">Live</Badge>;
  if (status === "paused") return <Badge variant="warning">Pauset</Badge>;
  if (status === "scheduled") return <Badge variant="accent">Planlagt</Badge>;
  if (status === "pending_review") return <Badge variant="warning">Til godkjenning</Badge>;
  if (status === "approved") return <Badge variant="accent">Godkjent</Badge>;
  if (status === "changes_requested") return <Badge variant="destructive">Endringer ønsket</Badge>;
  if (status === "pending_seller_decision") return <Badge variant="warning">Venter på selger</Badge>;
  if (status === "negotiating") return <Badge variant="warning">Forhandling</Badge>;
  if (status === "no_bids") return <Badge variant="muted">Ingen bud</Badge>;
  if (status === "sold") return <Badge variant="success">Solgt</Badge>;
  if (status === "no_sale") return <Badge variant="secondary">Ikke solgt</Badge>;

  if (status === "invoice_pending") return <Badge variant="warning">Faktura utestående</Badge>;
  if (status === "payment_pending") return <Badge variant="warning">Avventer betaling</Badge>;
  if (status === "ready_for_pickup") return <Badge variant="accent">Klar til å hente</Badge>;
  if (status === "picked_up") return <Badge variant="accent">Hentet av transportør</Badge>;
  if (status === "in_transit") return <Badge variant="accent">Under transport</Badge>;
  if (status === "delivered") return <Badge variant="success">Levert</Badge>;
  if (status === "complaint_review") return <Badge variant="destructive">Reklamasjon</Badge>;
  if (status === "pending_payout") return <Badge variant="warning">Avventer utbetaling</Badge>;
  if (status === "paid_out") return <Badge variant="success">Utbetalt</Badge>;
  return <Badge variant="muted">Utkast</Badge>;
}

export function LineStatusBadge({ status }: StatusBadgeProps) {
  if (status === "pending" || status === "queued") return <Badge variant="warning">{status}</Badge>;
  if (status === "invoiced" || status === "sent" || status === "payment_pending") return <Badge variant="accent">{status}</Badge>;
  if (status === "paid") return <Badge variant="success">paid</Badge>;
  return <Badge variant="muted">{status}</Badge>;
}
